export const elementIds = {
    email: 'sign-in-email',
    password: 'sign-in-password',
    submit: 'sign-in-submit',
};
